import { createSlice } from '@reduxjs/toolkit';

interface ProjectTeamType {
  internalTeam: { userId: number; name: string }[];
  externalTeam: { vendorId: number; name: string }[];
}

const initialState: ProjectTeamType = {
  internalTeam: [],
  externalTeam: [],
};

export const ProjectTeamSlice = createSlice({
  name: 'project-team',
  initialState,
  reducers: {
    addInternalProjectMember(state, { payload }) {
      state.internalTeam.push(payload);
    },
    deleteInternalProjectMember(state, { payload }) {
      state.internalTeam = state.internalTeam.filter((b, _i) => b.userId !== payload);
    },

    addExternalProjectMember(state, { payload }) {
      state.externalTeam.push(payload);
    },
    deleteExternalProjectMember(state, { payload }) {
      state.externalTeam = state.externalTeam.filter((b, _i) => b.vendorId !== payload);
    },
  },
});

export const { addInternalProjectMember, deleteInternalProjectMember, addExternalProjectMember, deleteExternalProjectMember } =
  ProjectTeamSlice.actions;
export default ProjectTeamSlice.reducer;
